<section class="api-keys-shell">
  <header class="page-header">
    <div>
      <p class="eyebrow">Security</p>
      <h1>Domain API keys</h1>
      <p class="context-site">Viewing <strong>{{ selectedSiteName }}</strong></p>
      <p class="intro">
        Create, review, and revoke site-scoped API keys for public integrations. Each key belongs to a single domain record.
      </p>
    </div>
    <button type="button" class="ghost" (click)="openSitesPage()">Manage sites</button>
  </header>

  @if (sites.length) {
    <section class="summary-strip" aria-label="API key summary">
      <div class="summary-cell">
        <span>Total domains</span>
        <strong>{{ sites.length }}</strong>
      </div>
      <div class="summary-cell">
        <span>Domains with keys</span>
        <strong>{{ totalSitesWithKeys }}</strong>
      </div>
      <div class="summary-cell">
        <span>Keys for {{ selectedSiteName }}</span>
        <strong>{{ apiKeys.length }}</strong>
      </div>
    </section>
  }

  @if (error) {
    <p class="error">{{ error }}</p>
  }

  @if (sites.length) {
    <section class="create-panel">
      <header class="create-panel-header">
        <div>
          <p class="eyebrow">Provision</p>
          <h2>Create a new key</h2>
        </div>
      </header>

      <div class="create-form">
        <label>
          <span>Key label</span>
          <input [(ngModel)]="draftName" placeholder="Public feed consumer" />
        </label>
        <button type="button" class="accent" [disabled]="saving || !draftName.trim()" (click)="createKey()">
          {{ saving ? 'Creating...' : 'Create key' }}
        </button>
      </div>
    </section>

    <section class="table-panel">
      <header class="table-panel-header">
        <div>
          <p class="eyebrow">Registry</p>
          <h2>Issued keys</h2>
        </div>
        <p class="table-note">{{ loading ? 'Refreshing key inventory...' : 'Delete a key to rotate compromised access.' }}</p>
      </header>

      @if (apiKeys.length) {
        <div class="table-wrap">
          <table>
            <thead>
              <tr>
                <th scope="col">Label</th>
                <th scope="col">API key</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              @for (apiKey of apiKeys; track apiKey.id) {
                <tr>
                  <td class="key-name">{{ apiKey.name }}</td>
                  <td class="key-value-cell"><code class="key-value">{{ apiKey.keyPreview }}</code></td>
                  <td>
                    <button type="button" class="danger small" (click)="deleteKey(apiKey)">Delete</button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      } @else if (loading) {
        <p class="empty-state">Loading API keys for {{ selectedSiteName }}.</p>
      } @else {
        <p class="empty-state">No API keys issued for {{ selectedSiteName }} yet.</p>
      }
    </section>
  } @else {
    <section class="table-panel">
      <header class="table-panel-header">
        <div>
          <p class="eyebrow">Security</p>
          <h2>No domains available</h2>
        </div>
      </header>
      <p class="empty-state">Create a site first before issuing API keys.</p>
    </section>
  }
</section>

@if (createdKeyDialog) {
  <div class="dialog-backdrop" (click)="closeCreatedKeyDialog()">
    <section
      class="dialog-panel"
      role="dialog"
      aria-modal="true"
      aria-labelledby="created-api-key-title"
      (click)="$event.stopPropagation()">
      <header class="dialog-header">
        <div>
          <p class="eyebrow">New API key</p>
          <h2 id="created-api-key-title">{{ createdKeyDialog.name }}</h2>
        </div>
        <button type="button" class="ghost small" (click)="closeCreatedKeyDialog()">Close</button>
      </header>

      <p class="panel-copy">Copy this key now. After this dialog is closed, only the masked preview remains visible.</p>

      <label class="latest-key-field">
        <span>API key value</span>
        <input [value]="createdKeyDialog.key" readonly />
      </label>

      @if (copyMessage) {
        <p class="copy-message">{{ copyMessage }}</p>
      }

      <div class="dialog-actions">
        <button type="button" class="accent" (click)="copyCreatedKey()">Copy key</button>
        <button type="button" class="ghost" (click)="closeCreatedKeyDialog()">Done</button>
      </div>
    </section>
  </div>
}
